<template>
	<div class="todo-view">
		<div class="header">
			<div class="label">
				<div class="primary">TODO</div>
				<div class="secondary">{{ todo.user ? todo.user.name : '' }}</div>
			</div>
			<div :class="['due', getColor(5)]">5</div>
		</div>
		<div class="tasks">
			<div class="task">{{ todo.message }}</div>
		</div>
		<div class="buttons">
			<div @click="complete(todo.id)">Afslut</div>
			<div @click="edit(todo.id)">Rediger</div>
			<div @click="del(todo.id)">Slet</div>
		</div>
	</div>
</template>

<script>
	import TodoModel from '../model/todo';

	import { bus } from '../../bus';

	export default {
		props: ['todo'],
		methods: {
			getColor(due) {
				if (due > 0) 	return 'green';
				if (due == 0) 	return 'yellow';
				if (due < 0) 	return 'red';
			},
			async del(id) {
				await TodoModel.del(id);
				bus.$emit('update');
			},
			async complete(id) {
				await TodoModel.close(id);
				bus.$emit('update');
			},
			async edit(id) {
				TodoModel.open(id, () => {
					bus.$emit('update');
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	.todo-view {
		box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);

		background-color: white;
		overflow: hidden;
		margin-bottom: 20px;
		border-radius: 5px;

		& > .header {
			display: grid;
			grid-template-columns: 1fr 50px;

			& > .label {
				padding: 8px 0 0 8px;

				& > .primary {
					font-size: 14px;
					font-weight: bold;
				}

				& > .secondary {
					font-size: 12px;
				}
			}

			& > .due {
				font-weight: bold;
				line-height: 50px;
				text-align: center;
				color: white;
				
				&.green {
					background-color: green;
				}

				&.yellow {
					background-color: rgb(224, 183, 0);
				}

				&.red {
					background-color: rgb(124, 0, 0);
				}
			}
		}

		& > .tasks {
			& > .task {
				border-top: 1px solid #cecece;
				font-size: 12px;
				padding: 8px;
			}
		}

		& > .buttons {
			display: grid;
			grid-template-columns: 1fr 1fr 1fr;
			border-top: 1px solid #cecece;

			& > div {
				border-left: 1px solid #cecece;
				text-align: center;
				line-height: 40px;
				cursor: pointer;

				&:first-child {
					border-left: none;
				}
			}
		}
	}
</style>